// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wantCancellDocument_YCMtv {
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 15px;
  flex: 1 0;
  border-radius: 8px;
  border: 1px solid var(--ececf1-border);
  background: var(--white-background);
  width: 70%;
  margin: 20px auto;
  color: #38343d;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; 
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/WantCancelDocument/CancelDocument.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".wantCancellDocument {\n  display: flex;\n  padding: 20px;\n  align-items: center;\n  gap: 15px;\n  flex: 1 0 0;\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n  background: var(--white-background);\n  width: 70%;\n  margin: 20px auto;\n  color: #38343d;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wantCancellDocument": `wantCancellDocument_YCMtv`
};
export default ___CSS_LOADER_EXPORT___;
